const themeProperties = {
  defaultFontFamily:
    '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
  fontSizes: {
    fontXXSmall: '10px',
    fontXSmall: '12px',
    fontSmall: '14px',
    fontSixteen: '16px',
    fontMedium: '18px',
    fontLarge: '22px',
    fontXLarge: '26px',
    fontXXLarge: '36px',
    fontXXXLarge: '48px',
  },
  designSystem: {
    colors: {
      /** Planet Green */
      primaryColor: '#007A49',
      primaryColorTransparent7: '#007A4911',
      primaryColorTransparent10: '#007A491A',
      // Greens
      forestGreen: '#219653',
      forestGreenTransparent20: '#21965333',
      forestGreenTransparent40: '#21965366',
      leafGreen: '#27AE60',
      leafGreenTransparent10: '#27AE601A',
      brightGreen: '#6FCF97',
      softGreen: '#F0FAF4',
      mintGradient: 'linear-gradient(180deg, #C9EFD9 0%, #D7F2C1 267.26%)',
      mintGradientStart: '#C9EFD9',
      // Yellows
      goldenYellow: '#F3BB44',
      softYellow: '#FFF8E4',
      // Browns/Chocolates
      darkChocolate: '#2F211B',
      softDarkChocolate: '#EFE2DD',
      milkChocolate: '#6D4230',
      softMilkChocolate: '#FDF3EA',
      // Blues/Purples
      purpleSky: '#6C63FF',
      purpleSkyTransparent10: '#6C63FF1A',
      purpleSkyTransparent20: '#6C63FF33',
      softSky: '#F3F2FF',
      oceanBlue: '#2F80ED',
      softBlue: '#EFF6FF',
      deepPurple: '#9B51E0',
      deepPurpleTransparent10: '#9B51E01A',
      softPurple: '#F9F1FF',
      // Reds
      fireRed: '#EB5757',
      fireRedTransparent10: '#EB57571A',
      softRed: '#FFF3F3',
      // Text Colors
      coreText: '#333333',
      softText: '#4F4F4F',
      softText2: '#828282',
      hintText: '#BDBDBD',
      // Background Colors
      white: '#FFFFFF',
      whiteTransparent10: '#FFFFFF1A',
      backgroundBase: '#F0F6F5',
      // Extended Palette
      warmGreen: '#68B030',
      warmGreenTransparent10: '#68B0301A',
      sunriseOrange: '#F2994A',
      sunriseOrangeTransparent10: '#F2994A1F',
      brightYellow: '#F2C94C',
      warmBlue: '#2D9CDB',
      warmBlueTransparent10: '#2D9CDB1A',
      warmBlueTransparent20: '#2D9CDB33',
      skyBlue: '#56CCF2',
      brightBlue: '#48AADD',
      warmRed: '#E86F56',
      hotPink: '#EB67CE',
      baseGrey: '#F9F9F9',
      // Gray colors for borders/separators etc.
      darkGrey: '#4F4F4F',
      mediumGrey: '#BDBDBD',
      mediumGreyTransparent30: '#BDBDBD4D',
      mediumGreyTransparent50: '#BDBDBD80',
      mediumGreyTransparent70: '#BDBDBDB3',
      // Dark Colors
      deepBlue: '#082447',
      deepGreen: '#003333',
    },
  },
  primaryColor: '#68B030',
  primaryDarkColor: '#007a49',
  primaryDarkColorTransparent: '#007a491a',
  primaryLightColor: '#79AE4633',
  lightBlueColor: '#48AADD',
  darkBlackColor: '#4F4F4F',
  darkOliveGreen: '#688816',
  topProjectBackgroundColor: '#F3BB44',
  mediumGrayColor: '#828282',
  lightGrayColor: '#f2f2f2',
  skyBlueColor: '#87ceeb',
  nonDonatableProjectBackgroundColor: '#828282',
  primaryColorNew: '#219653',
  horizontalLineColorNew: '#bdbdbd',
  restorationToggleColorNew: '#2f80ed',
  exploreDescriptionBackground: '242, 242, 242',
  greenTwo: '#27ae60',
  light: {
    primaryFontColor: '#2f3336',
    dividerColor: '#d5d5d5',
    secondaryColor: '#ecb641',
    highlightBackground: '#4d5153',
    backgroundColor: '#fff',
    light: '#fff',
    dark: '#000',
    dangerColor: '#e74c3c',
    safeColor: '#2980b9',
    backgroundColorDark: '#F2F2F7',
    unDecadeFill: '#1d1d1b',
    mapboxIcon: 'invert(0) hue-rotate(180deg)',
    backgroundBase: '#F0F6F5',
    disabledFontColor: '#909090',
    tabBackgroundColor: '#f4ffec',
    boldFontColorNew: '#2F3336',
    dividerColorNew: '#BDBDBD',
    dangerColorNew: '#E86F56',
    borderColor: '211, 211, 211',
  },
  dark: {
    primaryFontColor: '#ffffff',
    dividerColor: '#101113',
    secondaryColor: '#ecb641',
    backgroundColor: '#343a40',
    highlightBackground: '#f2f2f2',
    light: '#fff',
    dark: '#000',
    darkNew: '#333333',
    dangerColor: '#00ef00',
    safeColor: '#2980b9',
    backgroundColorDark: '#101113',
    unDecadeFill: '#fff',
    mapboxIcon: 'invert(0.8) hue-rotate(180deg)',
    backgroundBase: '#202020',
    disabledFontColor: '#686868',
  },
  fontWeight: '700',
};

export default themeProperties;
